<template>
  <div id="app">
    <div id="nav">
      <div class="nav-content">
        <div class="logo-section" @click="jump('-1')">
          <img class="logo" src="./assets/logo.png" />
          <div class="project-info">
            <div class="main-title">山 东 省 护 理 学 会</div>
            <div class="sub-title">ShanDong Nursing Association</div>
          </div>
        </div>

        <div class="menu-section">
          <el-menu
            :default-active="$store.state.navIndex"
            class="el-menu-nav"
            mode="horizontal"
            @select="jump"
            background-color="#ffffff"
            text-color="#275CAE"
            active-text-color="#275CAE"
          >
            <el-menu-item
              v-for="(menu, menuIdx) in getMenuList()"
              :key="menuIdx"
              :index="menuIdx.toString()"
              class="nav-item"
              >{{ menu.name }}</el-menu-item
            >
          </el-menu>
        </div>

        <div class="user-section" v-if="showAvatar()">
          <el-dropdown trigger="hover" @command="handleCommand">
            <div class="avatar-wrapper">
              <span class="nickname">{{ getNickName() }}</span>
              <el-avatar
                :size="32"
                :src="getAvatarUrl()"
                class="user-avatar"
              ></el-avatar>
              <i class="el-icon-caret-bottom dropdown-icon"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="mine"><i class="el-icon-user"></i> 个人中心</el-dropdown-item>
              <el-dropdown-item command="password"><i class="el-icon-lock"></i> 修改密码</el-dropdown-item>
              <el-dropdown-item command="phone"><i class="el-icon-mobile-phone"></i> 修改手机号</el-dropdown-item>
              <el-dropdown-item command="commonProblem"><i class="el-icon-question"></i> 常见问题</el-dropdown-item>
              <el-dropdown-item command="logout"><i class="el-icon-switch-button"></i> 退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <div class="main" :class="{ 'has-fixed-footer': isFixedFooterRoute }">
      <!--需要缓存组件-->
      <keep-alive>
        <!--router-view组件是一个 functional 组件，渲染路径匹配到的视图组件-->
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <!--不需要缓存组件-->
      <router-view v-if="!$route.meta.keepAlive" />
    </div>

    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="860px"
      :close-on-click-modal="false"
      append-to-body
      custom-class="app-password-dialog"
    >
      <el-form
        ref="passwordFormRef"
        :model="passwordForm"
        label-width="90px"
        class="dialog-form"
      >
        <el-form-item label="原密码" required>
          <el-input
            v-model.trim="passwordForm.oldPassword"
            type="password"
            show-password
            maxlength="20"
            autocomplete="new-password"
            placeholder="请输入原密码"
          />
        </el-form-item>
        <el-form-item label="新密码" required>
          <el-input
            v-model.trim="passwordForm.newPassword"
            type="password"
            show-password
            maxlength="20"
            autocomplete="new-password"
            placeholder="请输入新密码"
          />
        </el-form-item>
        <el-form-item label="确认密码" required>
          <el-input
            v-model.trim="passwordForm.rePassword"
            type="password"
            show-password
            maxlength="20"
            autocomplete="new-password"
            placeholder="请再次输入新密码"
          />
          <div class="dialog-tip" style="color:#909399;font-size:12px;margin-top:4px;">密码为6-20位，可由数字、字母、符号组成。</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="passwordSubmitting"
          @click="submitPasswordChange"
        >
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改手机号"
      :visible.sync="phoneDialogVisible"
      width="860px"
      :close-on-click-modal="false"
      append-to-body
      custom-class="app-phone-dialog"
    >
      <el-form
        ref="phoneFormRef"
        :model="phoneForm"
        label-width="90px"
        class="dialog-form"
      >
        <el-form-item label="新手机号" required>
          <el-input
            v-model.trim="phoneForm.newPhone"
            maxlength="11"
            placeholder="请输入新手机号"
          />
        </el-form-item>
        <el-form-item label="验证码" required>
          <div class="sms-row">
            <el-input
              v-model.trim="phoneForm.checkCode"
              maxlength="6"
              placeholder="请输入验证码"
            />
            <el-button
              class="sms-btn"
              :disabled="smsSending || smsCountdown > 0"
              @click="sendPhoneSmsCode"
            >
              {{
                smsCountdown > 0
                  ? `${smsCountdown}s后重试`
                  : smsSending
                  ? "发送中..."
                  : "获取验证码"
              }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="phoneDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="phoneSubmitting"
          @click="submitPhoneChange"
        >
          确定
        </el-button>
      </div>
    </el-dialog>

    <div class="footer" :class="{ 'is-fixed-bottom': isFixedFooterRoute }">
      <span class="copyright"
        >山东省护理学会 Shandong Nursing Association 备案许可证编号:
        鲁ICP备10040104号-2</span
      >
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      singleMenuList: [{ name: "首页", path: "/" }],
      fullMenuList: [
        { name: "首页", path: "/home" },
        { name: "专科", path: "/examsList?majorType=0" },
        { name: "专项", path: "/examsListzx?majorType=1" },
        { name: "专题", path: "/examsListzt?majorType=2" },
        { name: "师资", path: "/examsListsz?majorType=3" },
        { name: "实践技能", path: "/expert?isHome=1" },
        { name: "我的培训", path: "/studyPage" }
      ],
      passwordDialogVisible: false,
      passwordSubmitting: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        rePassword: ""
      },
      phoneDialogVisible: false,
      phoneSubmitting: false,
      phoneForm: {
        newPhone: "",
        checkCode: ""
      },
      smsSending: false,
      smsCountdown: 0,
      smsTimer: null
    };
  },
  created() {
    this.syncCurrentUser();
  },
  beforeDestroy() {
    this.clearSmsTimer();
  },
  computed: {
    isFixedFooterRoute() {
      if (!this.$route) return false;
      const fixedRoutes = [
        "/examInfo",
        "/expert",
        "/expertCertification",
        "/choicePracticeBase"
      ];
      return fixedRoutes.includes(this.$route.path);
    }
  },
  watch: {
    passwordDialogVisible(val) {
      if (!val && !this.passwordSubmitting) {
        this.resetPasswordForm();
      }
    },
    phoneDialogVisible(val) {
      if (!val && !this.phoneSubmitting) {
        this.resetPhoneForm();
      }
    }
  },
  methods: {
    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: "",
        newPassword: "",
        rePassword: ""
      };
      this.passwordSubmitting = false;
    },
    resetPhoneForm() {
      this.phoneForm = {
        newPhone: "",
        checkCode: ""
      };
      this.phoneSubmitting = false;
      this.smsSending = false;
      this.smsCountdown = 0;
      this.clearSmsTimer();
    },
    clearSmsTimer() {
      if (this.smsTimer) {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
      }
    },
    startSmsCountdown() {
      this.clearSmsTimer();
      this.smsCountdown = 60;
      this.smsTimer = setInterval(() => {
        if (this.smsCountdown <= 1) {
          this.smsCountdown = 0;
          this.clearSmsTimer();
          return;
        }
        this.smsCountdown -= 1;
      }, 1000);
    },
    validatePhone(phone) {
      return /^1\d{10}$/.test(String(phone || "").trim());
    },
    async sendPhoneSmsCode() {
      if (this.smsSending || this.smsCountdown > 0) {
        return;
      }
      if (!this.validatePhone(this.phoneForm.newPhone)) {
        this.$message.error("请输入正确的11位手机号");
        return;
      }
      this.smsSending = true;
      try {
        const res = await httpRequest("/common/sms", "put", {
          phone: this.phoneForm.newPhone
        });
        if (res && res.code === 200) {
          this.$message.success("验证码已发送，请注意查收");
          this.startSmsCountdown();
        }
      } catch (e) {
        void e;
      } finally {
        this.smsSending = false;
      }
    },
    async submitPasswordChange() {
      if (this.passwordSubmitting) {
        return;
      }
      const oldPassword = (this.passwordForm.oldPassword || "").trim();
      const newPassword = (this.passwordForm.newPassword || "").trim();
      const rePassword = (this.passwordForm.rePassword || "").trim();
      if (!oldPassword) {
        this.$message.error("请输入原密码");
        return;
      }
      if (!newPassword || newPassword.length < 6 || newPassword.length > 20) {
        this.$message.error("新密码长度需为6-20位");
        return;
      }
      if (newPassword !== rePassword) {
        this.$message.error("两次输入的新密码不一致");
        return;
      }
      this.passwordSubmitting = true;
      try {
        const res = await httpRequest("/app/user/rePassword2", "put", {
          oldPassword,
          password: newPassword,
          rePassword
        });
        if (res && res.code === 200) {
          this.$message.success("修改密码成功，请重新登录");
          this.passwordDialogVisible = false;
          localStorage.removeItem("pc_user_token");
          localStorage.removeItem("pc_user");
          this.$router.push("/login");
        }
      } catch (e) {
        void e;
      } finally {
        this.passwordSubmitting = false;
      }
    },
    async submitPhoneChange() {
      if (this.phoneSubmitting) {
        return;
      }
      const newPhone = (this.phoneForm.newPhone || "").trim();
      const checkCode = (this.phoneForm.checkCode || "").trim();
      if (!this.validatePhone(newPhone)) {
        this.$message.error("请输入正确的11位手机号");
        return;
      }
      if (!checkCode) {
        this.$message.error("请输入验证码");
        return;
      }
      this.phoneSubmitting = true;
      try {
        const res = await httpRequest("/app/user/new-phone", "put", {
          newPhone,
          checkCode
        });
        if (res && res.code === 200) {
          this.$message.success("手机号修改成功");
          this.phoneDialogVisible = false;
          this.resetPhoneForm();
          await this.syncCurrentUser();
        }
      } catch (e) {
        void e;
      } finally {
        this.phoneSubmitting = false;
      }
    },
    async handleLogout() {
      try {
        await httpRequest("/app/user/logout", "put", null);
      } catch (e) {
        void e;
      }
      localStorage.removeItem("pc_user_token");
      localStorage.removeItem("pc_user");
      this.$message.success("您已退出登录");
      this.$router.push("/login");
    },
    jump(key) {
      if (key === "-1") {
        this.$router.push("/");
        this.$store.state.navIndex = "0";
        return;
      }
      const menuList = this.getMenuList();
      const targetIndex = parseInt(key) < 0 ? 0 : parseInt(key);
      this.$store.state.navIndex = targetIndex.toString();
      this.$router.push(menuList[targetIndex].path);
    },
    getMenuList() {
      // 判断当前是否已经登录了
      const userToken = localStorage.getItem("pc_user_token");
      if (
        userToken === null ||
        userToken === undefined ||
        userToken.length === 0
      ) {
        this.$store.state.navIndex = "0";
        return this.singleMenuList;
      } else {
        return this.fullMenuList;
      }
    },
    getLocalUser() {
      const user = localStorage.getItem("pc_user");
      if (!user) {
        return null;
      }
      try {
        return JSON.parse(user);
      } catch (e) {
        return null;
      }
    },
    getDefaultAvatar() {
      return require("./assets/defaultAvatar.png");
    },
    normalizeAvatarUrl(avatarUrl) {
      if (!avatarUrl || typeof avatarUrl !== "string") {
        return "";
      }
      const trimmedUrl = avatarUrl.trim();
      if (!trimmedUrl) {
        return "";
      }
      if (
        trimmedUrl.startsWith("http://") ||
        trimmedUrl.startsWith("https://") ||
        trimmedUrl.startsWith("data:") ||
        trimmedUrl.startsWith("blob:")
      ) {
        return trimmedUrl;
      }
      if (trimmedUrl.startsWith("//")) {
        return `${window.location.protocol}${trimmedUrl}`;
      }
      if (trimmedUrl.startsWith("/")) {
        return `${window.location.origin}${trimmedUrl}`;
      }
      return trimmedUrl;
    },
    extractAvatarUrl(userObj) {
      if (!userObj || typeof userObj !== "object") {
        return "";
      }
      const candidates = [
        userObj.avatar,
        userObj.avatarUrl,
        userObj.avatar_url,
        userObj.pictureUrl,
        userObj.picture_url,
        userObj.headImg,
        userObj.headImgUrl,
        userObj.head_img_url,
        userObj.photo
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const normalized = this.normalizeAvatarUrl(candidates[i]);
        if (normalized) {
          return normalized;
        }
      }
      return "";
    },
    getAvatarUrl() {
      const userObj = this.getLocalUser();
      const avatarUrl = this.extractAvatarUrl(userObj);
      return avatarUrl || this.getDefaultAvatar();
    },
    getNickName() {
      const userObj = this.getLocalUser();
      if (!userObj || typeof userObj !== "object") {
        return "";
      }
      const nicknameCandidates = [
        userObj.nickname,
        userObj.nickName,
        userObj.realName,
        userObj.real_name,
        userObj.phone
      ];
      for (let i = 0; i < nicknameCandidates.length; i += 1) {
        const value = nicknameCandidates[i];
        if (typeof value === "string" && value.trim().length > 0) {
          return value.trim();
        }
      }
      return "";
    },
    showAvatar() {
      // 判断当前是否已经登录了
      const userToken = localStorage.getItem("pc_user_token");
      if (
        userToken === null ||
        userToken === undefined ||
        userToken.length === 0
      ) {
        return false;
      } else {
        return true;
      }
    },
    async syncCurrentUser() {
      if (!this.showAvatar()) {
        return;
      }
      try {
        const res = await httpRequest("/app/user", "get", null);
        if (
          res &&
          res.code === 200 &&
          res.data &&
          typeof res.data === "object"
        ) {
          localStorage.setItem("pc_user", JSON.stringify(res.data));
        }
      } catch (e) {
        // Keep local data when request fails.
      }
    },
    handleCommand(command) {
      if (command === "mine") {
        this.$router.push("/mine");
        return;
      }
      if (command === "password") {
        this.resetPasswordForm();
        this.passwordDialogVisible = true;
        return;
      }
      if (command === "phone") {
        this.resetPhoneForm();
        this.phoneDialogVisible = true;
        return;
      }
      if (command === "commonProblem") {
        this.$router.push("/commonProblem");
        return;
      }
      if (command === "logout") {
        this.$confirm("确定要退出吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.handleLogout();
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
#app {
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1200px;
  background-color: #f5f7fa;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#nav {
  height: 77px;
  background-color: #ffffff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.4);
  position: sticky;
  top: 0;
  z-index: 100;

  .nav-content {
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
  }

  .logo-section {
    display: flex;
    align-items: center;
    cursor: pointer;

    .logo {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }

    .project-info {
      text-align: left;

      .main-title {
        font-size: 20px;
        font-weight: 800;
        color: #1e295b;
        line-height: 1.2;
        font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
          sans-serif;
      }

      .sub-title {
        font-size: 14px;
        font-weight: 400;
        color: #1e295b;
        margin-top: 0px;
        font-family: Arial, sans-serif;
        transform: scale(0.9);
        transform-origin: left top;
      }
    }
  }

  .menu-section {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    margin-left: 100px; /* Gap from logo section */

    .el-menu-nav {
      border-bottom: none;

      .nav-item {
        font-size: 14px;
        font-weight: 700;
        height: 77px;
        line-height: 77px;
        padding: 0 10px;
        margin: 0 10px;
        border-bottom: 2px solid transparent;
        transition: all 0.3s;
        color: #275cae;

        &.is-active {
          border-bottom: 2px solid #275cae;
          background-color: transparent !important;
          color: #275cae;
        }

        &:hover {
          color: #275cae !important;
          background-color: transparent !important;
        }
      }
    }
  }

  .user-section {
    min-width: 150px;
    display: flex;
    justify-content: flex-end;

    .avatar-wrapper {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 6px 10px 6px 16px;
      border-radius: 24px;
      transition: background-color 0.2s;

      &:hover {
        background-color: #f5f7fa;
      }

      .nickname {
        font-size: 14px;
        color: #333;
        font-weight: 500;
        margin-right: 12px;
      }

      .user-avatar {
        border: 2px solid #f0f0f0;
      }

      .dropdown-icon {
        margin-left: 8px;
        color: #909399;
        font-size: 12px;
        transition: transform 0.2s;
      }

      // Rotate the arrow when the dropdown is hovered
      &:hover .dropdown-icon {
        transform: rotate(180deg);
      }
    }
  }
}

.main {
  flex: 1;
  width: 100%;
  margin-top: 0;
  // padding-bottom: 20px;

  &.has-fixed-footer {
    padding-bottom: 50px;
  }
}

.footer {
  width: 100%;
  height: 50px;
  background-color: #035db3;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #939393; // 保持正式环境提取的颜色，或者改为 #ffffffaa 以增加对比度
  margin-top: auto;

  &.is-fixed-bottom {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 90;
    margin-top: 0;
  }

  .copyright {
    opacity: 0.8;
  }
}

::v-deep .app-password-dialog,
::v-deep .app-phone-dialog {
  border-radius: 8px;

  .el-dialog__header {
    padding: 18px 24px;
    border-bottom: 1px solid #f1f5f9;
  }

  .el-dialog__title {
    font-size: 18px;
    color: #111827;
    font-weight: 500;
  }

  .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
    font-size: 18px;
  }

  .el-dialog__body {
    padding: 24px 28px 8px 28px;
  }

  .dialog-form {
    .el-form-item {
      margin-bottom: 22px;
    }

    .el-form-item__label {
      color: #334155;
      font-size: 14px;
      padding-right: 12px;
      &::before {
        color: #ef4444;
      }
    }

    .el-input__inner {
      height: 40px;
      line-height: 40px;
      border-color: #d9e2ef;
      border-radius: 4px;
      font-size: 14px;
    }
  }

  .dialog-tip {
    margin-top: 10px;
    color: #4b5563;
    font-size: 20px;
    line-height: 1.5;
    text-align: left;
  }

  .dialog-footer {
    padding: 10px 28px 22px 28px;
    text-align: right;
  }
}

::v-deep .app-phone-dialog {
  .sms-row {
    display: flex;
    align-items: center;
    width: 100%;

    .el-input {
      flex: 1;
    }
  }

  .sms-btn {
    margin-left: 0;
    width: 130px;
    height: 44px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
  }
}
</style>
